<div class="main">
  <div class="row">
    <ds-amfam-faq-links
      [isPartner]="isPartner | async"
      class="column twelve md-two"
    ></ds-amfam-faq-links>
    <ds-amfam-faq class="column twelve md-ten">
      <ng-container header>Frequently Asked Questions</ng-container>
      <ng-container questions>
        <ds-accordion [allowMultipleOpenCategories]="true" [allowToggleAccordion]="true">
          @for (question of faqContent | async; track question) {
            <ds-accordion-category [title]="question.title">
              <p [innerHtml]="question.body"></p>
            </ds-accordion-category>
          }
        </ds-accordion>
      </ng-container>
    </ds-amfam-faq>
  </div>
</div>
